export default Object.freeze({
  BASE_URL: "https://warpa-api.arianhassani.dev/api/",

  AUTH_URL: "auth/",
  USER_URL: "user/",
  BOOKING_REQUEST: "booking_request/",
  LOGS_URL: "logs/",
  TASK_URL: "task/",
  TASK_REQUEST_URL: "task_request/",
  PAYMENT_URL: "payment/",
  FILES: "files/",
  CLOUDIE: "cloudie/",
  EVENT_URL: "event/",

  LOGIN: "login/",
  CHECK_TOKEN_VALIDITY: "check_token_validity/",
  REGISTER: "register/",
  WEEKLY_AVAILABILITY_TEMPLATE: "weekly_availability_template/",
  DATE_AVAILABILITY: "date_availability/",
  DATE_TO_TEMPLATE: "date_to_template/",
  TAGS: "tags/",
  SEARCH: "search/",
  FREE_SLOTS: "free_slots/",
  ACCEPTED: "accepted/",
  EMERGENCY_REQUEST: "emergency_request/",
  GUEST: "guest/",
  MODEL: "model/",
  PARENT: "parent/",
  LINKS: "links/",
  CHILDREN: "children/",
  CLOUD_STORAGE_LIMIT: "cloud_storage_limit/",
  DEACTIVATE: "deactivate/",
  SUSPEND: "suspend/",
  DETAILS: "details/",
  DETACH_FROM_PARENTS: "detach_from_parents/",
  AVAILABLE: "available/",
  ACCESSIBLE_USERS: "accessible_users/",
  PREFERENCES: "preferences/",
  TASK_STATUS: "status/",
  TASK_ASSIGN: "assign/",
  TASK_MORE_TIME: "more_time/",
  RECEIVED: "received/",
  SENT: "sent/",
  AUTOMATIC: "automatic/",
  UPCOMING: "upcoming/",
  CANCEL: "cancel/",
  FOLDER: "folder/",
  FILE: "file/",
  DOWNLOAD: "download/",
  ACCESS: "access/",
  STORAGE_REQUEST: "storage_request/",
  VPS: "vps/",
  THUMBNAIL: "thumbnail/",
  COLLABORATOR: "collaborator/",
  PRIORITY: "priority/",
  BANNER: "banner/",
  INVITE: "invite/",
  INVITATIONS: "invitations/",
  JOIN: "join/",
  RESTRICT: "restrict/",
  SETTLE: "settle/",
  PUBLIC: "public/",
  MINE: "mine/",
  MEDIA_ACCESS: "media_access/",
  SCHEDULE: "schedule/",
  RESCHEDULE: "reschedule/",
  WITHDRAW: "withdraw/",
  CONNECTED_RELATIVES: "connected_relatives/",
});
